import { renderAllTabsOnPrint } from "../common/print/renderAllTabsOnPrint";
import { initRestrictedPopovers } from "../common/restrictedPopovers";
import { waitForElement } from "../common/waitForElement";
import { initSidebar } from "./sidebar";
import { stickyTableData } from "./stickyTableData";
import { toggleRows } from "./toggleRows";
import { copyLink } from "../copyLink";

export function initProfile(defaultTabId) {
	initSidebar(defaultTabId);
	renderAllTabsOnPrint();

	waitForElement(".content-box").then(() => {
		initRestrictedPopovers();
		toggleRows();
		copyLink(
			".content-box .data-list .data-value button[data-copy-link]",
			(button) => button.parentElement.querySelector("a").href,
		);
	});

	window.initFeedbackPopup(".feedback-link");
	window.initModals();
	stickyTableData(".content-box");

	window.addEventListener("hashchange", function (e) {
		e.preventDefault();
		window.initFeedbackPopup(".feedback-link");
		window.initModals();
		stickyTableData(".content-box");
	});
}
